import { IResourceComponentsProps, useNavigation, useShow } from '@pankod/refine-core'
import { WorkRequestsTable } from 'components/workrequests'
export const WorkRequestsList: React.FC<IResourceComponentsProps> = () => {
  const { show } = useNavigation()
  return <WorkRequestsTable />
}
